import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPackageHotelMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  packageHotelInput: GraphQLTypes.CreateHotelPackageInput;
}>;


export type AddPackageHotelMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'addPackageHotel'>
);


export const AddPackageHotelDocument = /*#__PURE__*/ gql`
    mutation addPackageHotel($packageId: String!, $packageHotelInput: CreateHotelPackageInput!) {
  addPackageHotel(packageId: $packageId, packageHotelInput: $packageHotelInput)
}
    `;

/**
 * __useAddPackageHotelMutation__
 *
 * To run a mutation, you first call `useAddPackageHotelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageHotelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageHotelMutation, { data, loading, error }] = useAddPackageHotelMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      packageHotelInput: // value for 'packageHotelInput'
 *   },
 * });
 */
export function useAddPackageHotelMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageHotelMutationResult, AddPackageHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageHotelMutationResult, AddPackageHotelMutationVariables>(AddPackageHotelDocument, options);
      }
export type AddPackageHotelMutationHookResult = ReturnType<typeof useAddPackageHotelMutation>;